import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";
import { scrollToId } from "@/components/SmoothScroll";

export default function Manifesto() {
  return (
    <section
      data-testid="research-section"
      className="relative py-28 md:py-36 px-6 md:px-12 overflow-hidden"
    >
      <div className="max-w-4xl mx-auto">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="text-xs font-bold uppercase tracking-[0.28em] text-[#E7B459] mb-8"
        >
          The research
        </motion.p>

        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          data-testid="research-headline"
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]"
        >
          We're still figuring this out —{" "}
          <span className="text-[#D9544E]">with you</span>.
        </motion.h2>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          data-testid="research-body"
          className="mt-10 text-lg sm:text-xl leading-relaxed text-[#F4F1ED]/80 max-w-2xl border-l-2 border-[#E7B459]/40 pl-6"
        >
          How do we accurately measure the health of parts in your bike? Do we
          fit a{" "}
          <span className="text-[#F4F1ED] font-semibold">tracker in your bike</span>
          {" "}— a hardware approach that could cost us mass adoption — or can we
          build a{" "}
          <span className="text-[#F4F1ED] font-semibold">software model</span>,
          AI- and machine-learning-backed, that reaches the same accuracy? Help
          us shape this research —{" "}
          <button
            onClick={() => scrollToId("waitlist")}
            data-testid="research-join-link"
            className="text-[#E7B459] font-semibold underline decoration-[#E7B459]/40 underline-offset-4 hover:decoration-[#E7B459] transition-colors"
          >
            join by registering your interest below
          </button>
          .
        </motion.p>
      </div>
    </section>
  );
}
